import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import {downloadFailureCsvFromBase64, ImportErrorRow} from './bulk-import-result.utils';

@Component({
    selector: 'app-bulk-import-result',
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: './bulk-import-result.component.html',
    styleUrl: './bulk-import-result.component.css',
})
export class BulkImportResultComponent {
    @Input() totalImported = 0;
    @Input() totalFailed = 0;
    @Input() errors: ImportErrorRow[] = [];
    @Input() failedRowsCsvBase64: string | null = null;
    @Input() failedRowsFilename = 'import_failures.csv';
    @Input() downloadButtonLabel = 'Download Failure Report';

    constructor(library: FaIconLibrary) {
        library.addIcons(faDownload);
    }

    downloadFailureReport(): void {
        if (!this.failedRowsCsvBase64) {
            return;
        }
        downloadFailureCsvFromBase64(this.failedRowsCsvBase64, this.failedRowsFilename);
    }
}
